<content>
    <section class="entry-inline-framed">
        <label>{{'consumos.incidencias.consumo' | translate}}</label> {{consumoId}}
    </section>
    <table>
        <thead>
            <tr>
                <th class="date">{{'consumos.incidencias.fecha' | translate}}</th>
                <th class="string">{{'consumos.incidencias.des' | translate}}</th>
                <th class="number">{{'consumos.incidencias.numEtiquetas' | translate}}</th>
                <th class="number">{{'consumos.incidencias.etqAfectadas' | translate}}</th>
                <th class="string">{{'consumos.incidencias.guardadas' | translate}}</th>
                <th class="string">{{'consumos.incidencias.gestionada' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let incidencia of incidencias; let i = index">
            <tr>
                <td class="date">{{incidencia.fecha | date:"dd/MM/yyyy"}}</td>
                <td class="string">{{incidencia.des}}</td>
                <td class="number">{{incidencia.numeroEtiquetasSolicitadas | number : '1.0-0': defaultLanguage}}</td>
                <td class="number">{{incidencia.numeroEtiquetasEfectivas | number : '1.0-0': defaultLanguage}}</td>
                <td class="string">{{incidencia.etiquetasDisponibles ? ('global.si' | translate) : ('global.no' | translate)}}</td>
                <td class="string">{{incidencia.gestionada ? ('global.si' | translate) : ('global.no' | translate)}}</td>
            </tr>
        </tbody>
        <tfoot *ngIf="!incidencias || (incidencias && incidencias.length < 1)">
            <tr>
                <td colspan="6">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cerrar' | translate}}</button>
</footer>